import {
  Button,
  Flex,
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  Text,
} from '@chakra-ui/react';

const OverduePaymentModal = ({ isOpen, onClose, handle, isUpdatePaymentBtnLoading}) => {
    return (
      <>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent className="modal__simple modal_take-a-part"
              maxW={{ sm: '620px' }}
              style={{ border:'1px solid #2ABDFD', overflow: 'hidden' }}>
          <ModalCloseButton style={{zIndex: '9'}} />
              <Box bg="rgba(64, 155, 255, 0.82)" filter="blur(70px)" w="90%" h="150px"
                  transform="translate(-50%, 0px)" left="50%"
                  top="-200px" position="absolute" borderRadius="full" />

              <Box position="relative" p="0 8px 0 8px" textAlign="center">
                  <Text
                      variant="title-lg"
                      zIndex="3"
                      pt="24px"
                      fontSize="32px"
                      fontStyle="italic"
                      fontWeight="700"
                      position="relative">Payment Failed</Text>

                  <Text mt="16px" fontStyle="italic" p={{base: '0', md: '0 70px'}}>
                      You have an overdue payment for your LMCT+ subscription. Some benefits are temporarily unavailable.
                  </Text>

                  <Flex mt="40px" gap="12px">
                    <Button variant="secondary-md" onClick={onClose}>Close</Button>
                    <Button
                      isLoading={isUpdatePaymentBtnLoading}
                      variant="button-md"
                      onClick={handle}>Update Payment</Button>
                  </Flex>
              </Box>
          </ModalContent>
        </Modal>
      </>
    );
};

export default OverduePaymentModal;
